// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ripple-container{position:absolute;left:0;top:0;height:0;width:0;pointer-events:none;overflow:hidden}.ripple-effect{margin-top:0;margin-left:0;width:.03125rem;height:.03125rem;-webkit-transition:all .6s cubic-bezier(.4,0,.2,1);transition:all .6s cubic-bezier(.4,0,.2,1);border-radius:50%;pointer-events:none;position:relative;z-index:9999}", ""]);
// Exports
module.exports = exports;
